const PUBLIC_EXACT_PATHS = ['/completed-documents'];
const PUBLIC_TOKEN_PATH_PREFIXES = [
  '/sign/',
  '/completed-documents/',
  '/referrals/access/'
];

// Detected at module-evaluation time, BEFORE React Router mounts. Public token
// routes must opt out of any telemetry / support tooling that would capture the
// bearer token in the URL or any rendered PHI (signatures, names).
export function isPublicESignRoute() {
  return (
    typeof window !== 'undefined' &&
    (PUBLIC_EXACT_PATHS.includes(window.location.pathname) ||
      PUBLIC_TOKEN_PATH_PREFIXES.some((prefix) =>
        window.location.pathname.startsWith(prefix)
      ))
  );
}

export function isPublicSignerRoute() {
  return isPublicESignRoute();
}
